/** Вид узла: раздел и статья держат детей, остальные — блоки содержимого, листья */
export enum EnumLibreKind {
  SECTION = 'section',
  ARTICLE = 'article',
  TEXT = 'text',
  ESSENCE = 'essence',
  CODE = 'code',
  QUOTE = 'quote',
  LINK = 'link',
}

export const STRUCTURE_KINDS: EnumLibreKind[] = [EnumLibreKind.SECTION, EnumLibreKind.ARTICLE]
export const CONTENT_KINDS: EnumLibreKind[] = [EnumLibreKind.TEXT, EnumLibreKind.ESSENCE, EnumLibreKind.CODE, EnumLibreKind.QUOTE, EnumLibreKind.LINK]

export function isStructureKind(kind: EnumLibreKind): boolean {
  return STRUCTURE_KINDS.includes(kind)
}

export function isLibreKind(value: unknown): value is EnumLibreKind {
  return typeof value === 'string' && (Object.values(EnumLibreKind) as string[]).includes(value)
}
